var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBasicCheck = function SvgBasicCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 26,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#basic-check_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#basic-check_svg__b)",
    d: "M26.123 10.382c.178.856.269 1.737.269 2.619 0 7.167-5.92 12.999-13.195 12.999S0 20.168 0 12.999C0 5.829 5.92 0 13.195 0c2.386 0 4.724.635 6.76 1.833.616.362.818 1.149.449 1.756a1.31 1.31 0 0 1-1.782.441 10.7 10.7 0 0 0-5.427-1.47c-5.843 0-10.597 4.683-10.597 10.439s4.754 10.44 10.597 10.44 10.597-4.684 10.597-10.44c0-.709-.073-1.417-.217-2.106a1.28 1.28 0 0 1 1.013-1.51 1.3 1.3 0 0 1 1.533.997zm1.513-8.617a1.315 1.315 0 0 0-1.838-.033L13.124 13.769l-3.226-3.373a1.31 1.31 0 0 0-1.837-.054 1.265 1.265 0 0 0-.054 1.81l4.127 4.314c.239.249.568.394.915.402h.03c.336 0 .661-.127.904-.358L27.602 3.575a1.27 1.27 0 0 0 .034-1.812z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "basic-check_svg__b",
    x1: 2.162,
    x2: 23.488,
    y1: 15.467,
    y2: 15.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F7A79"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "basic-check_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v26H0z"
  })))));
};
export default SvgBasicCheck;